import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Button,
  Flex,
  useColorModeValue,
} from '@chakra-ui/react';
import { useRecoilValue } from 'recoil';
import { useNavigate } from 'react-router-dom';
import { isReadOnlySelector, licenseStatusSelector, licenseLoadingAtom } from '../../state/licenseAtom';
import { isAdminSelector } from '../../state/userAtom';

function ReadOnlyBanner() {
  const isReadOnly = useRecoilValue(isReadOnlySelector);
  const licenseStatus = useRecoilValue(licenseStatusSelector);
  const licenseLoading = useRecoilValue(licenseLoadingAtom);
  const isAdmin = useRecoilValue(isAdminSelector);
  const navigate = useNavigate();

  const bgColor = useColorModeValue('orange.50', 'orange.900');
  const borderColor = useColorModeValue('orange.200', 'orange.700');

  // Don't show banner while license is still loading to prevent flash
  if (licenseLoading || !isReadOnly) {
    return null;
  }

  const getMessage = () => {
    switch (licenseStatus) {
      case 'none':
        return 'No license key has been configured.';
      case 'expired':
        return 'Your license has expired.';
      case 'invalid':
        return 'Your license key is invalid.';
      default:
        return 'A valid license is required.';
    }
  };

  return (
    <Box
      position="sticky"
      top={0}
      zIndex={1000}
      bg={bgColor}
      borderBottom="1px solid"
      borderColor={borderColor}
      px={4}
      py={2}
    >
      <Alert
        status="warning"
        variant="subtle"
        bg="transparent"
        borderRadius="lg"
        py={1}
      >
        <AlertIcon />
        <Flex
          direction={{ base: 'column', md: 'row' }}
          align={{ base: 'flex-start', md: 'center' }}
          justify="space-between"
          w="full"
          gap={2}
        >
          <Box>
            <AlertTitle fontSize="sm" fontWeight="600" mb={0}>
              Read-Only Mode
            </AlertTitle>
            <AlertDescription fontSize="sm">
              {getMessage()} You can view data but cannot make changes.
            </AlertDescription>
          </Box>
          {isAdmin && (
            <Button
              size="sm"
              colorScheme="orange"
              variant="solid"
              onClick={() => navigate('/settings?tab=license')}
              flexShrink={0}
            >
              Manage License
            </Button>
          )}
        </Flex>
      </Alert>
    </Box>
  );
}

export default ReadOnlyBanner;
